//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoBadgePosition from './demos/DemoBadgePosition.vue'
import DemoBadgeStyle from './demos/DemoBadgeStyle.vue'
import DemoBadgeType from './demos/DemoBadgeType.vue'
import DemoBadgeColor from './demos/DemoBadgeColor.vue'
import DemoBadgeShowOnHover from './demos/DemoBadgeShowOnHover.vue'
import DemoBadgeDynamicNotifications from './demos/DemoBadgeDynamicNotifications.vue'
import DemoBadgeTabs from './demos/DemoBadgeTabs.vue'
import DemoBadgeAvatarStatus from './demos/DemoBadgeAvatarStatus.vue'

// code
import {
  badgePosition,
  badgeStyle,
  badgeType,
  badgeColor,
  badgeShowOnHover,
  badgeDynamicNotifications,
  badgeTabs,
  badgeAvatarStatus,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoBadgePosition,
    DemoBadgeStyle,
    DemoBadgeType,
    DemoBadgeColor,
    DemoBadgeShowOnHover,
    DemoBadgeDynamicNotifications,
    DemoBadgeTabs,
    DemoBadgeAvatarStatus,
  },
  setup() {
    return {
      codeSnippets: {
        badgePosition,
        badgeStyle,
        badgeType,
        badgeColor,
        badgeShowOnHover,
        badgeDynamicNotifications,
        badgeTabs,
        badgeAvatarStatus,
      },
    }
  },
}
